import {
  SHOP_DETAIL, SHOP_DETAIL_FAILURE, SHOP_DETAIL_SUCCESS
} from './mutation-types'

export default {
  state: {
    shop: null
  },
  getters: {
    shopDetail: state => {
      return state.shop
    }
  },
  actions: {
    [SHOP_DETAIL] ({dispatch, state, commit}, params) {
      var url = '/master/shops/' + params.id
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_DETAIL_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(SHOP_DETAIL_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHOP_DETAIL_FAILURE] (state, data) {
      console.log('SHOP_DETAIL_FAILURE')
    },
    [SHOP_DETAIL_SUCCESS] (state, data) {
      console.log('SHOP_DETAIL_SUCCESS')
      state.shop = data.data
      data.callback()
      state.loading = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop-detail.js